import { Component, OnInit, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { Router } from '@angular/router';
declare var $: any; // TODO hide modal in othe way

// Notifications
declare var OneSignal: any;

// ICS
declare var ics;

// Services
import {
  UserService,
  ResourceService,
  OpentokService
} from "@services/index.service";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

// App Constants
import { AppConstants } from '@app/appConstants';

// App Settings
import { environment } from "@environments/environment";
import { TranslateService } from '@ngx-translate/core';

/** Esta página lista todas las citas del usuario incluidas las de sus dependientes junto a las opciones para cada una de ellas */
@Component({
  selector: 'app-myappointments',
  templateUrl: './myappointments.page.html',
  styleUrls: ['./myappointments.page.scss'],
  animations: environment.ANIMATIONS
})
export class MyappointmentsComponent implements OnInit, OnDestroy {
  hoursToCancel = environment.HOURS_TO_CANCEL_APPOINTMENTS || 0;
  daysToConfirmAppointmentFrom;
  daysToConfirmAppointmentTo;
  /** Para el modal de confirmación necesito almacenar el slot seleccionado */
  selectedSlot: any;
  alert;
  /** Almacenamos el dependiente cuando estamos trabajando en una de sus citas */
  dependent;
  message;
  dayToCancel;
  LOGO = environment.LOGO;
  /**Valor extraido del environment para saber si mostar el botón de videoConsulta. Seguramente se pueda quitar cuando esa información
   * nos llegue en el slot
   */
  hasVideoCall = environment.VIDEOCALL.HAS;
  hasMyDepents = environment.HASMYDEPENTS;
  environmentName = environment.envName;

  OptionButtons = environment.BUTTONS_ON_MY_APPOINTMENTS;

  appointmentsNeedConfirmaton = environment.NEED_CONFIRM_APPOINTMENTS;

  constructor(public router: Router,
    public _userService: UserService,
    public _resourceService: ResourceService,
    public translate: TranslateService,
    private _opentokService: OpentokService) {
    /** Al cargar el componente pedimos todas las citas del usuario. También es en
     * este componente donde damos la posibilidad al usuario de recibir alertas en caso de que tenga activado los Service Workers
    */

    this._resourceService.loading = true;
    if (this.appointmentsNeedConfirmaton) {
      this.getDaysToConfirmAppointments();
    } else {
      this.reloadInformation();
    }
    // Uncomment if use SignalOne Service
    /* if (environment.serviceWorker) {
      var self = this;
      OneSignal.push(function () {
        OneSignal.init({
          appId: "3d06dedc-cba6-4fcc-8a30-07441c8f77d9",
        });
        OneSignal.setEmail(self._userService.user.email);
        OneSignal.sendTags({
          userId: self._userService.user.id,
          email: self._userService.user.email
        }).then(function (tagsSent) {
          // Callback called when tags have finished sending
        });
      });
    } */

  }

  getDaysToConfirmAppointments() {
    this._resourceService.getResource('confirmDays').subscribe(data => {
      let response = data as ResponseDataBase;
      this.daysToConfirmAppointmentFrom = parseInt(response.result.filter(item => item.id === 'FROM').map(item => item.name));
      this.daysToConfirmAppointmentTo = parseInt(response.result.filter(item => item.id === 'TO').map(item => item.name));
      this.reloadInformation();
      this._resourceService.loading = false;
    });
  }

  /** Para evitar comportamientos raros lo primero vacioamos las citas del paciente antes de volverlas a pedir. Luego
   * cargamos todas las citas del usuario y recorremos todos sus dependientes pidiendo también las citas de cada uno */
  reloadInformation() {
    this._userService.loading = true;
    delete this._userService.user.appointments;
    this._userService.getAppointments('').subscribe(data => {
      let response = data as ResponseDataBase;
      this._userService.user.appointments = response.result;
      if (this._userService.user.appointments && this._userService.user.appointments.length) {
        let now = moment();
        let self = this;
        this._userService.user.appointments.forEach(function (appointment) {
          // Estoy poniendo todas las citas sin confirmar, pero debería recibirlo del back y de SAP
          appointment.isConfirmed = appointment.confrim;
          appointment.isConfirmable = false;
          appointment.isCancelable = true;
          appointment.appointmentMoment = moment(appointment.date + ':' + appointment.hour);
          appointment.firstDayToConfirm = moment(appointment.date + ':' + appointment.hour, "YYYY-MM-DD").subtract(self.daysToConfirmAppointmentFrom, 'days').format("DD-MM-YYYY");
          appointment.lastDayToConfirm = moment(appointment.date + ':' + appointment.hour, "YYYY-MM-DD").subtract(self.daysToConfirmAppointmentTo, 'days').format("DD-MM-YYYY");

          // Comprbamos si la fecha esta dentro de los días para confirmar (al último día añadimos uno porque toma desde las 00:00)
          if (moment().isBetween(moment(appointment.firstDayToConfirm, "DD-MM-YYYY"), moment(appointment.lastDayToConfirm, "DD-MM-YYYY").add(1, 'days'))) {
            appointment.isConfirmable = true;
          }
          let diffHours = appointment.appointmentMoment.diff(now, 'hours');
          if (self.hoursToCancel && diffHours < self.hoursToCancel) {
            appointment.isCancelable = false;
          }
        });
      }
      if (environment.HASMYDEPENTS && this._userService.user.dependents && this._userService.user.dependents.length) {
        let self = this;
        let hoursToCancel = this.hoursToCancel;
        this._userService.user.dependents.forEach(function (dependent, index) {
          let params = {
            dependentId: dependent.id
          }
          self._userService.getAppointments(params).subscribe(data => {
            let response = data as ResponseDataBase;
            dependent.appointments = response.result;
            let now = moment()
            dependent.appointments.forEach(function (appointment) {
              appointment.isCancelable = true;
              let appointmentMoment = moment(appointment.date + ':' + appointment.hour);
              let diffHours = appointmentMoment.diff(now, 'hours');
              if (hoursToCancel && diffHours < hoursToCancel) {
                appointment.isCancelable = false;
              }
            });
            self._userService.loading = false;
            self._resourceService.loading = false;
          });
        });
      } else {
        this._userService.loading = false;
        this._resourceService.loading = false;
      }
    }, err => {
      this._userService.checkError(err);
    });
  }

  confirmAppointment(appointment) {
    console.log('confirmAppointment', appointment)
    appointment.isConfirmed = true;
  }


  /** Esta función manda al back el id del slot a cancelar, y en caso de que se haga bien recarga la informacion. */
  deleteAppointment() {
    window.scrollTo(0, 0);
    let params = {
      appointmentId: this.selectedSlot.id,
      patientId: this.dependent?.id
    };
    this._userService.doActionPatient('deleteappointment', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK || response.METADATA.STATUS === AppConstants.STATUS.PAPID_REMOVED) {
        this.reloadInformation();
      } else {
        console.log('ERROR', response);
      }
    });
    delete this.selectedSlot;
  }

  deleteDatabaseAppointment() {
    window.scrollTo(0, 0);
    let params = {
      day: this.selectedSlot.date,
      schedule: this.selectedSlot.hour
    };
    this._userService.cancelDatabaseSlot(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK || response.METADATA.STATUS === AppConstants.STATUS.PAPID_REMOVED) {
        this.getPatientDatabaseBookedslots();
      } else {
        console.log('ERROR', response);
      }
    });
    delete this.selectedSlot;
  }

  confirmUnconfirmedAppointment(appointment) {
    let params = {
      appointmentId: appointment.id
    };
    this._userService.doActionPatient('confirmunconfirmedappointment', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this.reloadInformation();
      } else {
        console.log('ERROR', response);
      }
    });
    delete this.selectedSlot;
  }

  /** Seleccionamos el slot y en su caso el dependiente para poder trabajar con él */
  selectSlotToCancel(slot, dependent) {
    this.dependent = dependent;
    this.selectedSlot = slot;
    this.dayToCancel = moment(this.selectedSlot.date).locale(this.translate.currentLang).format('LL');
  }



  /** Completamos la información del slot con la información que no tenemos */
  showComplete(freeslot) {
    let hospital = this._resourceService.hospitals.filter(obj => {
      return obj.id === freeslot.einri
    })
    this._resourceService.selectedFreeslot = freeslot;
    this._resourceService.selectedFreeslot.hospital = hospital[0];
  }

  addToGoogleCalendar(slot) {
    let googleCalendarurlBase = "https://www.google.com/calendar/render?action=TEMPLATE&";
    let appointmentWith = slot.doctor?.name || slot.department?.name;
    let title = "text=" + this.translate.instant('APPOINTMENT_WITH') + " " + appointmentWith;
    let location = "&location=" + slot.department?.name.replace("&", "AND");
    let st = slot.date + ' ' + slot.hour;
    let dateStart = moment(st).utc().format('YYYYMMDDTHHmmss[Z]');
    let dateEnd = moment(st).add(30, 'minutes').utc().format('YYYYMMDDTHHmmss[Z]');
    let dates = "&dates=" + dateStart + '%2F' + dateEnd;
    let googleCalendarurl = googleCalendarurlBase + title + location + dates;
    window.open(googleCalendarurl);
  }

  /** Esta función añade un elemento al calendario del usuario.  Creamos el objeto que añadiresmo y rellenamos los parámetros que va
   * a necesitar con la información que sacamos del slot
  */
  addToCalendar(slot) {
    this._resourceService.loading = true;
    let cal = ics();
    let title = slot.doctor?.name || slot.department?.name;
    let a = this.translate.instant('APPOINTMENT_WITH');
    let message = a + ' ' + title;
    let location = slot.department?.name || "";
    let st = slot.date + ' ' + slot.hour;
    let dateStart = moment(st);
    let dateEnd = moment(st).add(30, 'minutes');
    cal.addEvent(title, message, location, dateStart, dateEnd);
    cal.download();
    this._resourceService.loading = false;
  }

  pdfBlobConvesion(b64Data) {
    var sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    var byteCharacters = window.atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays);
    return blob;
  }


  /** Creamos un pdf con la información del Slot. */
  print(slot) {
    // En caso de que nos devuelva el pdf SAP
    if (1) {
      let params = {
        ITmnid: slot.id
      }
      this._userService.printAppointment(params).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
          if (this._resourceService.getBrowserInfo() == 'IE 11') {
            var blob = this.pdfBlobConvesion(response.result[0].name);
            (window.navigator as any).msSaveOrOpenBlob(blob, "myappointment.pdf");
          } else {
            let pdf = response.result;
            const linkSource = pdf[0].name;
            const downloadLink = document.createElement("a");
            const fileName = 'myappointment' + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            this._userService.loading = false;
          }

          // Esto abre el pdf en una nueva pestaña
          /*           let pdfWindow = window.open("");
                let pdf = response.result[0].name;
                pdfWindow.document.write("<iframe width='100%' height='100%' src='" + pdf + "'></iframe>");
                this._userService.loading = false; */


        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
          this._userService.loading = false;
        }
      });
    }
    // Podríamos imprimir directamente desde el front si no SAP no nos devuelve bien el pdf
    else {
      slot.hospital = this._resourceService.hospitals.filter(obj => {
        return obj.id === slot.einri
      })
      this.selectedSlot = slot;
      let context = this;
      setTimeout(this.windowPrint.bind(context), 400);
      this._resourceService.loading = false;
    }
  }

  windowPrint() {
    window.print()
  }

  /** Pasamos la información del slot al _opentokService y navegamos a la pantalla donde tiene lugar la video consulta */
  goToVideoCall(slot) {
    window.open("https://cms-nodejs.commonms.com:3001/?key=MjAyMDA0MjJfMTAwMDAwX1BBVElFTlRfMDAwMDAwMDAwMQ==")
    /*this._opentokService.videoCallSlot = slot;
    this.router.navigate(['/user/videocall']); */
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    delete this._resourceService.selectedFreeslot;
  }

  getPatientDatabaseBookedslots() {
    this._userService.getPatientDatabaseAppointments().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this._userService.user.appointments = response.result;
        this._userService.user.appointments.forEach(function (appointment) {
          appointment.isCancelable = true;
        });
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._userService.loading = false;
      this._resourceService.loading = false;
    });
  }

}
